import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import BasketMixDesktop from "./BasketMixDesktop";
import BasketMixMobile from "./BasketMixMobile";

function BasketMix({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <BasketMixMobile app={app} config={config} />
  ) : (
    <BasketMixDesktop app={app} config={config} />
  );
}

BasketMix.defaultProps = {
  app: null,
  config: {},
};

BasketMix.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default BasketMix;
